var ProductRecommendationAction = /* @__PURE__ */ ((ProductRecommendationAction2) => {
  ProductRecommendationAction2["AddToCart"] = "addToCart";
  ProductRecommendationAction2["AddQuantity"] = "addQuantity";
  ProductRecommendationAction2["Redirect"] = "redirect";
  return ProductRecommendationAction2;
})(ProductRecommendationAction || {});
var BannerRecommendationAction = /* @__PURE__ */ ((BannerRecommendationAction2) => {
  BannerRecommendationAction2["DiscountCode"] = "discountCode";
  BannerRecommendationAction2["Link"] = "link";
  return BannerRecommendationAction2;
})(BannerRecommendationAction || {});
export {
  BannerRecommendationAction,
  ProductRecommendationAction
};
//# sourceMappingURL=types.js.map
